module.exports = __webpack_public_path__ + "static/img/036 6.689aa234.jpg";